import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SugargooSpreadsheetGuide from "../pages/article/SugargooSpreadsheetGuide";
import SugargooReview from "../pages/article/SugargooReview";
import ShippingGuide from "../pages/article/ShippingGuide";
import CouponGuide from "../pages/article/CouponGuide";
import WarehouseGuide from "../pages/article/WarehouseGuide";
import IsSugargooLegit from "../pages/article/IsSugargooLegit";
import SugargooVsAgents from "../pages/article/SugargooVsAgents";
import BuyingGuide from "../pages/article/BuyingGuide";
import HiddenFees from "../pages/article/HiddenFees";
import HowToUse from "../pages/article/HowToUse";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <SugargooSpreadsheetGuide />,
  },
  {
    path: "/sugargoo-review",
    element: <SugargooReview />,
  },
  {
    path: "/sugargoo-shipping-guide",
    element: <ShippingGuide />,
  },
  {
    path: "/sugargoo-coupon-guide",
    element: <CouponGuide />,
  },
  {
    path: "/sugargoo-warehouse-guide",
    element: <WarehouseGuide />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <IsSugargooLegit />,
  },
  {
    path: "/sugargoo-vs-other-agents",
    element: <SugargooVsAgents />,
  },
  {
    path: "/sugargoo-buying-guide",
    element: <BuyingGuide />,
  },
  {
    path: "/sugargoo-hidden-fees",
    element: <HiddenFees />,
  },
  {
    path: "/how-to-use-sugargoo-spreadsheet",
    element: <HowToUse />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;